// Framework and third-party non-ui
import React from 'react';
import {history} from '../../index';
// Redux operations and local helpers/utils/modules
import originFields from '../../defaults/PointOfOriginFields.json';

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import RaisedButton from 'material-ui/RaisedButton';

// JSON

// CSS

const ReportHeader = props => {
  const {incident} = props.selectedIncident;

  return (
    <div className="report-header">
      <RaisedButton
        className="report-back-btn"
        onClick={() => {
          history.push(`/incidents/${incident.attributes[originFields.forId]}`)
        }}
      label="Back" />
      <div className="report-titles">
        <p className="report-title">Final Fire Report</p>
        <p><span>Incident Name: </span> {incident.attributes[originFields.name]}</p>
      </div>
      <div className="report-ids">
        <p><span>FireCode: </span>{incident.attributes[originFields.fireCode] || 'NA'}</p>
        <p><span>Unique Fire ID: </span>{incident.attributes[originFields.uniqueFireId]}</p>
      </div>
      <RaisedButton
        className="report-print-btn"
        onClick={() => {document.title='INFORM_' + incident.attributes[originFields.uniqueFireId] + '_' + new Date().toISOString(); window.print(); return false;} }
        label="Print" />
    </div>
  );
}

ReportHeader.propTypes = {};

ReportHeader.defaultProps = {};

export default ReportHeader;
